module.exports = __webpack_public_path__ + "media/images/products/at2/at2-1-200x200-3df5a08d943da3386973b4991f9ebdfa.png";